module.exports = __webpack_public_path__ + "img/pickuplocation.2d350e22.png";